import { useEffect } from "react";
import { CustomState } from "../../../../Hooks/State.hook";
import { customRequest, CustomRequestOptions } from "../../../../services/api";
import { BarChart } from "@mui/x-charts";
import StyledMessagesByUser from "./style";
import UsersMessagesTable from "./table";
import { MessagesPerUserResponse, UserMessages } from "./types";
import InputDateRange from "../../../../components/InputDateRange";
import { defaultInput100, defaultInput50 } from "../../../../components-variants/defaultInputs";
import { RangeDate } from "../../../../interfaces/generics.types";
import toSqlDate from "../../../../Hooks/toSqlDate.util";
import { ButtonType1 } from "../../../../styles/buttons.style";
import { FaFilter } from "react-icons/fa6";
import LoadingSpinner from "../../../../components/LoadingSpinner";

function MessagesByUser() {
    const data = CustomState<UserMessages[]>([]);
    const filteredData = CustomState<UserMessages[]>([]);
    const loadingState = CustomState<boolean>(false);

    const dt = new Date();

    const dateRange = CustomState<RangeDate>({
        min: new Date(dt.getFullYear(), dt.getMonth(), 1),
        max: new Date(dt.getFullYear(), dt.getMonth() + 1, 0)
    });


    function loadData(range: RangeDate) {
        const requestData: CustomRequestOptions<MessagesPerUserResponse, undefined> = {
            endpoint: "/dashboard/messages-per-user",
            method: "get",
            onSuccess: (res) => {
                data.set(res.messagesPerUser);
                filteredData.set(res.messagesPerUser);
            },
            loadingState,
            timeoutSeconds: 90
        }

        if (range.min || range.max) {
            const minDate = range.min ? toSqlDate(range.min) : "";
            const maxDate = range.max ? toSqlDate(range.max) : "";

            requestData.params = {
                date: `${minDate}_${maxDate}`
            }
        }

        customRequest(requestData);
    }

    useEffect(() => {
        loadData(dateRange.value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const dataset = filteredData.value.map((o) => {
        return ({
            "attendances": Number(o.attendancesCount),
            "contacts": Number(o.contactsCount),

        })
    });

    return (
        <StyledMessagesByUser>
            <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                <div style={{ width: "40rem" }}>
                    <InputDateRange
                        title="Período"
                        state={dateRange}
                        {...defaultInput50}
                    />
                </div>
                <ButtonType1
                    style={{ fontSize: "1rem", width: "20rem" }}
                    onClick={() => loadData(dateRange.value)}

                >
                    <FaFilter />
                    Filtrar
                </ButtonType1>
            </div>
            {
                loadingState.value ?
                    <LoadingSpinner /> :
                    <>
                        <UsersMessagesTable
                            rowsState={data}
                            filteredRowsState={filteredData}
                        />
                        <div>
                            {
                                !!filteredData.value.length &&
                                <BarChart
                                    xAxis={[
                                        { dataKey: "name", scaleType: "band" },
                                    ]}
                                    series={[
                                        { dataKey: "contacts", label: "Clientes" },
                                        { dataKey: "attendances", label: "Atendimentos" },
                                    ]}
                                    height={600}
                                    colors={[
                                        "var(--color-btn-register-customers)",
                                        "var(--color-btn-mass-messages)",
                                        "var(--color-btn-register-contacts)",
                                    ]}
                                    dataset={dataset}
                                />
                            }
                        </div>
                    </>
            }
        </StyledMessagesByUser>
    );
}

export default MessagesByUser;